/* global s */
'use strict';

class TariffPlan {
	constructor(options) {
		this.defaults = {
			tariff_plan_country_list: {},
			tariff_plans: [],
			selected_country: '',
			selected_value: '',
			cached_rates: {},
			featured: false,
			tracking_params: {
				destination: 'Other',
				product_type: '',
				product_details: ''
			},
			page_selectors: {
				plan_sell_countries_id: 'plan-sell-countries',
				best_offer_text_holder: 'plan-subtitle',
				product_selector_id: 'product-selector-plan'
			},
			plan_selectors: {
				plan_option: '.plan-option',
				left_top: '.plan-left-top',
				left_bottom: '.plan-left-bottom',
				middle: '.plan-middle',
				right_top: '.plan-right-top',
				right_top_value: '.plan-right-top-value',
				right_top_text: '.plan-right-top-text',
				right_bottom: '.plan-right-bottom',
				container: '#buy-plan-container'
			},
			buy_form_selectors: {
				voice_quantity: 'voice_quantity',
				voice_product_id: 'voice_product_id',
				form_buy_voice: 'form_buy_voice',
				buy_button_id: 'buy-button'
			}
		};
		this.options = Object.assign(this.defaults, options);
		console.log('TariffPlan::constructor(%o)', this.options);
		this.pageEvents();
	}

	/**
	 * Displays the plans for a specific country.
	 * Fills the placeholders in plan_placeholder.html with the necessary details
	 * Calls highlightBestDeal to mark the best deal plan
	 *
	 * @param {string}   country_code    Country code for the country to display the plans foe
	 * @param {boolean}  featured        Feature the plans section
	 *
	 */

	displayCountryPlans(country_code, featured) {
		//console.log('TariffPlan::displayCountryPlans(%o, %o)', country_code, featured);
		$(this.options.plan_selectors.container).html('');
		if (country_code) {
			country_code = country_code.toUpperCase();
			if (this.options.tariff_plans[country_code]) {
				const _plan_template = $.parseHTML(s.options.plan_placeholder.html);
				this.options.tariff_plans[country_code].forEach(plan => {
					let _formatted_left_top, _formatted_left_bottom = '', _formatted_middle = '',
						_formatted_right_top_value, _formatted_right_top_text, _formatted_right_bottom;
					let _temp_plan_template = $(_plan_template).clone();

					if (plan.max_discount !== 0) {
						let _oldval = document.createElement('span');
						if (s.format_money(plan.price_per_month) !== s.format_money(plan.price - plan.max_discount)) {
							_oldval.innerHTML = s.format_money(plan.price_per_month);
							_oldval.style.textDecoration = 'line-through';
						}
						if (plan.billing_interval_months > 1) {
							_formatted_middle = `${_oldval.outerHTML} ${s.format_money(plan.price - plan.max_discount)}${s.it('PER_MONTH')}`;
						} else {
							_formatted_right_bottom = `${_oldval.outerHTML} ${s.format_money(plan.price - plan.max_discount)}${s.it('PER_MONTH')}`;
						}
					} else {
						if (plan.billing_interval_months > 1) {
							_formatted_middle = `${s.format_money(plan.price_per_month)}${s.it('PER_MONTH')}`;
						} else {
							_formatted_right_bottom = `${s.format_money(plan.price_per_month)}${s.it('PER_MONTH')}`;
						}
					}

					_formatted_left_top = `${plan.translated_name}`;
					if (Number(plan.minutes) === 0) {
						_formatted_right_top_value =
							s.svg('icon-infinity', '0 0 88 41', ['color-white', 'icon-infinity']);
					} else {
						_formatted_middle = `${s.format_money(plan.price_per_minute * 100, true, 1)}${s.it('PER_MIN')}`;
						_formatted_right_top_value = plan.minutes;
					}
					if (plan.billing_interval_months > 1) {
						_formatted_left_bottom = s.it('NO_OF_MONTHS', {'no_of_months' : plan.billing_interval_months});
						_formatted_right_top_value =
							s.svg('icon-infinity', '0 0 88 41', ['color-white', 'icon-infinity']);
						_formatted_right_bottom = `${s.format_money(plan.price)}/${s.it('NO_OF_MONTHS', {'no_of_months' : plan.billing_interval_months})}`;
					}

					_formatted_right_top_text = ` ${s.it('MIN')}`;

					if (plan.billing_interval_months === 1) {
						let _first_sell = parseFloat(plan.price) - parseFloat(plan.max_discount);
						let _recurring_sell = 0;
						if (plan.recurring_product) {
							_recurring_sell = parseFloat(plan.recurring_product.price) - parseFloat(plan.recurring_product.max_discount);
						}
						if (_first_sell < _recurring_sell) {
							_formatted_right_bottom = s.it('FIRST_MONTH_THEN_RECURRING', {
								'first_sell': s.format_money(_first_sell),
								'recurring_sell': s.format_money(_recurring_sell)
							});
							if (Number(plan.minutes) !== 0) {
								const first_price_per_min = _first_sell / plan.product_data.minutes * 100;
								const recurring_price_per_min = _recurring_sell / plan.product_data.minutes * 100;

								if (first_price_per_min !== recurring_price_per_min) {
									_formatted_middle = '<span class=\'fs-14\'>';
									_formatted_middle += s.it(
										'FIRST_MONTH_THEN_RECURRING', {
											'first_sell': `${s.format_money(first_price_per_min, true, 1)}${s.it('PER_MIN')}`,
											'recurring_sell': `${s.format_money(recurring_price_per_min, true, 1)}${s.it('PER_MIN')}`
										}
									);
									_formatted_middle += '</span>';
								} else {
									_formatted_middle = `${s.format_money(recurring_price_per_min, true, 1)}${s.it('PER_MIN')}`;
								}
							}
							_temp_plan_template
								.find(this.options.plan_selectors.right_bottom)
								.toggleClass('fs-16 fs-14')
								.addClass('plan-first-then');
						}
						_temp_plan_template
							.find(this.options.plan_selectors.right_bottom)
							.css({'line-height': 1});
					}
					this.options.tracking_params.destination = plan.target;
					this.options.tracking_params.product_details = _formatted_left_top;

					if (plan.product_data.destinations && plan.product_data.destinations.length > 0) {
						const countries = plan.product_data.destinations.map(destination => {
							return (destination.split('-')[0]).trim();
						});
						const unique_countries = countries.filter((value, index, self) => {
							return self.indexOf(value) === index;
						});
						const number_of_countries = Math.floor(unique_countries.length / 10) * 10;
						if (country_code !== 'WR') {
							const destination = typeof this.options.tariff_plan_country_list[country_code] !== 'undefined'
								? this.options.tariff_plan_country_list[country_code]
								: '';
							_formatted_left_bottom += s.it('INCLUDE_UNLIMITED_CALLS_TO_COUNTRY', {
								destination: destination,
								number_of_countries: number_of_countries,
							});
						} else {
							_formatted_left_bottom += s.it('INCLUDE_UNLIMITED_CALLS_TO', {
								number_of_countries: number_of_countries,
							});
						}
					}

					_temp_plan_template
						.find(this.options.plan_selectors.left_top)
						.html(_formatted_left_top);
					if (_formatted_left_bottom !== '') {
						_temp_plan_template
							.find(this.options.plan_selectors.left_bottom)
							.html(_formatted_left_bottom);
					} else {
						_temp_plan_template
							.find(this.options.plan_selectors.left_bottom)
							.remove();
					}
					if (_formatted_middle !== '') {
						_temp_plan_template
							.find(this.options.plan_selectors.middle)
							.html(_formatted_middle);
					} else {
						_temp_plan_template
							.find(this.options.plan_selectors.middle)
							.remove();
					}
					if (_formatted_right_top_value) {
						_temp_plan_template
							.find(this.options.plan_selectors.right_top_value)
							.html(_formatted_right_top_value);
					}
					if (_formatted_right_top_text) {
						_temp_plan_template
							.find(this.options.plan_selectors.right_top_text)
							.html(_formatted_right_top_text);
					}
					_temp_plan_template
						.find(this.options.plan_selectors.right_top)
						.after(document.createElement('hr'));
					_temp_plan_template
						.find(this.options.plan_selectors.right_bottom)
						.html(_formatted_right_bottom);
					_temp_plan_template.attr('data-plan', plan.id);

					$(this.options.plan_selectors.container).append(_temp_plan_template);
				});

				this.highlightBestDeal(country_code, featured);
				this.updateBestDealText(country_code);
			}
		}
	}

	/**
	 * Resets the styling for the _tariff_plan_section section
	 *
	 */

	resetPlans() {
		if (this.options.plan_selectors.plan_option !== 'undefined') {
			let _all_plans = document.querySelectorAll(this.options.plan_selectors.plan_option);
			if (_all_plans) {
				_all_plans.forEach( (el) => {
					el.classList.remove('active');
				});
			}
		}
		this.options.tracking_params.product_type = '';
	}

	/**
	 * Return the plan with the best deal
	 *
	 * @param {string}   country_code    Country code for the selected country
	 *
	 * @return {Object}  the plan with the best deal
	 *
	 */

	bestPlanDeal(country_code) {
		if (country_code && country_code in this.options.tariff_plans) {
			const plans = [...this.options.tariff_plans[country_code]];

			return plans.sort((a, b) => {
				if (a.price_per_minute === b.price_per_minute) {
					if (a.price_per_month === b.price_per_month) {
						return 0;
					}

					return a.price_per_month < b.price_per_month ? -1 : 1;

				}

				return a.price_per_minute < b.price_per_minute ? -1 : 1;

			})[0];
		}

		return null;
	}

	/**
	 * Marks the best deal plan
	 *
	 * @param {string}   country_code    Country code for the country to display the plans for
	 * @param {boolean}  select          Feature the specific plan
	 *
	 */

	highlightBestDeal(country_code, select) {
		if (country_code) {
			const _best_plan = this.bestPlanDeal(country_code);
			if (_best_plan) {
				const bestdeal_elements = document.querySelectorAll(`[data-plan='${_best_plan.id}']`);
				bestdeal_elements.forEach( bestdeal_element => {
					bestdeal_element.classList.add('plan-best-offer');
					if (select) {
						bestdeal_element.dispatchEvent(new Event('click', {bubbles: true}));
					}
				});
			}
		}
	}

	/**
	 * Return the text for the best deal for a specific country
	 *
	 * @param {string}   country_code    Country code for the selected country
	 *
	 * @return {string}  html code for the Best Deal text
	 *
	 */

	generateBestDealText(country_code) {
		let _best_deal_content = '';
		if (country_code) {
			let _best_plan = this.bestPlanDeal(country_code);
			if (_best_plan) {
				let __deal_minutes = '';
				let __deal_target = '';
				if (parseInt(_best_plan.product_data.minutes) === 0) {
					__deal_minutes = s.it('UNLIMITED_MINUTES');
				} else {
					__deal_minutes = s.format_money(_best_plan.price_per_minute * 100, true, 1) + s.it('PER_MIN');
					if (_best_plan.billing_interval_months === 1) {
						let _first_sell = parseFloat(_best_plan.price) - parseFloat(_best_plan.max_discount);
						let _recurring_sell = 0;
						if (_best_plan.recurring_product) {
							_recurring_sell = parseFloat(_best_plan.recurring_product.price) - parseFloat(_best_plan.recurring_product.max_discount);
						}
						if (_first_sell < _recurring_sell) {
							__deal_minutes = `${s.format_money(_recurring_sell / _best_plan.product_data.minutes * 100, true, 1)}${s.it('PER_MIN')}`;
						}
					}
				}
				if (typeof _best_plan.product_data.target_type !== 'undefined') {
					switch (_best_plan.product_data.target_type) {
						case 'landline':
							__deal_target = s.it('ALL_LANDLINES');
							break;

						case 'mobile':
							__deal_target = s.it('ALL_MOBILES');
							break;

						default:
							__deal_target = s.it('ALL_NUMBERS');
							break;
					}
				}
				_best_deal_content = `<strong>${s.it('BEST_DEAL')}:</strong> ${__deal_minutes} - ${__deal_target}`;
			}
		}

		return _best_deal_content;
	}

	updateBestDealText(country_code) {
		if (typeof this.options.page_selectors.best_offer_text_holder !== 'undefined') {
			let _plan_subtitle = document.getElementById(this.options.page_selectors.best_offer_text_holder);
			if (_plan_subtitle) {
				if (country_code) {
					_plan_subtitle.innerHTML = this.generateBestDealText(country_code);
				} else {
					_plan_subtitle.innerHTML = _plan_subtitle.dataset.initialText;
				}
			}
		}
	}

	/**
	 * Handles events on the page ( click/change/etc to call the right functions at the right time )
	 */

	changeVoiceDestination(country_name) {
		//console.log('TariffPlan::changeVoiceDestination(%o)', country_name);
		if (typeof s.voice_credit !== 'undefined') {
			const _credit_sell_countries = document.getElementById(s.voice_credit.options.credit_sell_countries_id);
			if (_credit_sell_countries) {
				for (let _i = 0;_i < _credit_sell_countries.length;_i++) {
					if (_credit_sell_countries.options[_i].value === country_name) {
						_credit_sell_countries.value = country_name;
						_credit_sell_countries.classList.remove('has-placeholder');
						s.common.changeFlag(_credit_sell_countries);
						s.voice_credit.getCountryRates(country_name, true);
					}
				}
			}
		}
	}
	pageEvents() {
		if (typeof this.options.page_selectors.plan_sell_countries_id !== 'undefined') {
			const _plan_sell_countries = document.getElementById(this.options.page_selectors.plan_sell_countries_id);
			if (_plan_sell_countries ) {
				_plan_sell_countries.addEventListener('change', () => {
					this.displayCountryPlans(
						_plan_sell_countries.options[_plan_sell_countries.selectedIndex].getAttribute('data-country-code'),
						true
					);
					if (_plan_sell_countries.value) {
						this.changeVoiceDestination(_plan_sell_countries.value);
					}
				});
			}
		}

		if (typeof this.options.plan_selectors.plan_option !== 'undefined') {
			let _this = this;
			$(document).on('click', this.options.plan_selectors.plan_option, function () {
				$(_this.options.plan_selectors.plan_option).removeClass('active');
				$(this).addClass('active');
				const ivd = document.getElementById(_this.options.buy_form_selectors.voice_quantity);
				if (ivd) {
					ivd.value = '1';
				}
				const ivpi = document.getElementById(_this.options.buy_form_selectors.voice_product_id);
				if (ivpi) {
					ivpi.value = $(this).attr('data-plan');
				}
				const ivbi = document.getElementById(_this.options.buy_form_selectors.buy_button_id);
				if (ivbi) {
					ivbi.disabled = false
				}
				_this.options.tracking_params.product_type = 'tariff_plan';
				if (typeof s.voice_credit_section !== 'undefined') {
					s.voice_credit_section.resetPredefined();
					s.voice_credit_section.resetCustom();
				}
				if (typeof s.voice_credit !== 'undefined') {
					s.voice_credit.resetPredefined();
				}
			});
		}

		if (typeof this.options.page_selectors.product_selector_id !== 'undefined') {
			let _product_selector = document.getElementById(this.options.page_selectors.product_selector_id);
			if (_product_selector) {
				_product_selector.addEventListener('change', () => {
					document.getElementById(this.options.buy_form_selectors.buy_button_id).disabled = true;
					if ($(this.options.plan_selectors.plan_option).length === 1) {
						$(this.options.plan_selectors.plan_option).addClass('active');
					}
					if ($(this.options.plan_selectors.plan_option).hasClass('active')) {
						document.getElementById(this.options.buy_form_selectors.voice_quantity).value = '1';
						document.getElementById(this.options.buy_form_selectors.voice_product_id).value =
							$(this.options.plan_selectors.plan_option + '.active').attr('data-plan');
						document.getElementById(this.options.buy_form_selectors.buy_button_id).disabled = false;
					}
					if (typeof s.voice_credit_section !== 'undefined') {
						s.voice_credit_section.resetPredefined();
						s.voice_credit_section.resetCustom();
					}
					if (typeof s.voice_credit !== 'undefined') {
						s.voice_credit.resetPredefined();
					}
				});
			}
		}

		if (this.options.buy_form_selectors.buy_button_id !== 'undefined') {
			let _submit_button = document.getElementById(this.options.buy_form_selectors.buy_button_id);
			if (_submit_button) {
				_submit_button.addEventListener('click', () => {
					if (this.options.tracking_params && this.options.tracking_params.product_type) {
						s.track.dataLayerPush({
							'event': 'gtm_remarketing',
							'destination': this.options.tracking_params.destination,
							'product_type': this.options.tracking_params.product_type,
							'product_details': this.options.tracking_params.product_details,
							'dynx_pagetype': 'conversionintent'
						});
					}
				});
			}
		}

		let selected_credit_country_name = '';
		let selected_tariff_plan_country_code = '';
		if (this.options.selected_country) {
			selected_credit_country_name = this.options.selected_country.name;
			if (Object.keys(this.options.tariff_plans).includes(this.options.selected_country.short)) {
				selected_tariff_plan_country_code = this.options.selected_country.short;
			} else {
				const _plan_sell_countries = document.getElementById(this.options.page_selectors.plan_sell_countries_id);
				if (!_plan_sell_countries) {
					selected_tariff_plan_country_code = Object.keys(this.options.tariff_plans)[0];
				}
			}
		}

		this.displayCountryPlans(selected_tariff_plan_country_code, this.options.featured);
		this.changeVoiceDestination(selected_credit_country_name);
	}
}
